module.exports = __webpack_public_path__ + "media/customizations/austinpoint/back-51b14d2ad6798945d1dee79f47155404.jpg";